import TYPES from '@/types';

// Application
import SignOutCommand
  from '@/modules/authentication/application/commands/sign-out-command';
import SignOutEmitter from '@/modules/authentication/application/emitters/sign-out-emitter';
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import { WebSocket } from '@/modules/shared/domain/web-socket';
import Inject from '@/modules/shared/domain/di/inject';
import SHARED_TYPES from '@/modules/shared/types';

export default class AuthenticatedLayoutViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.SIGN_OUT_COMMAND)
  private readonly sign_out!: SignOutCommand;

  @Inject(TYPES.SIGN_OUT_EMITTER)
  private readonly sign_out_emitter!: SignOutEmitter;

  @Inject(SHARED_TYPES.WEB_SOCKET)
  private readonly web_socket!: WebSocket;

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  initialize = () => {
    this.initializeListeners();
  }

  beforeUnloadHandler = async () => {
    this.sign_out_emitter.sendMessage('close_session', true);
  }

  appAuthTokenUpdatedHandler = async () => {
    this.sign_out_emitter.refreshToken();
  }

  subscribe = () => {
    const user_id = sessionStorage.getItem('user_id') || '';
    this.sign_out_emitter.connect(user_id);
  }

  initializeListeners = () => {
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
    window.addEventListener('app.auth.token.updated', this.appAuthTokenUpdatedHandler);
    this.subscribe();
  }
}
